import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import { getPolygonGeoObject } from '../index';

export function getMainPolygonGeoObject(
  newbuildingPolygon: number[][] | null,
  isDistanceCalculatingEnabled: boolean,
): IMapGeoObject | null {
  if (!newbuildingPolygon || !isDistanceCalculatingEnabled) {
    return null;
  }

  return getPolygonGeoObject({
    name: 'main',
    coordinates: newbuildingPolygon,
    id: '#newbuilding-polygon',
  });
}
